var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcAlertEmailError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FDE7E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 28C23.4477 28 23 28.4477 23 29C23 29.5523 23.4477 30 24 30V28ZM24.01 30C24.5623 30 25.01 29.5523 25.01 29C25.01 28.4477 24.5623 28 24.01 28V30ZM33 24C33 28.9706 28.9706 33 24 33V35C30.0751 35 35 30.0751 35 24H33ZM24 33C19.0294 33 15 28.9706 15 24H13C13 30.0751 17.9249 35 24 35V33ZM15 24C15 19.0294 19.0294 15 24 15V13C17.9249 13 13 17.9249 13 24H15ZM24 15C28.9706 15 33 19.0294 33 24H35C35 17.9249 30.0751 13 24 13V15ZM23 19V27H25V19H23ZM24 30H24.01V28H24V30Z",
    fill: "#EF2605"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAlertEmailError);
export default __webpack_public_path__ + "static/media/ic_alert_email_error.efe92107d236b356d2ada22a5bdb094e.svg";
export { ForwardRef as ReactComponent };